import styled, { css } from 'styled-components';
import Typography from '../../../../typography';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
const blockListItemTitleStyles = ({ theme }) => css `
	grid-area: title;
	margin: 0;
	max-width: none;
	text-overflow: ellipsis;
	overflow: hidden;
	hyphens: manual;
	color: ${theme.colors.base.textSubtitles};
`;
export const StyledBlockListItemTitle = styled(Typography).attrs({
    variant: 'component-title',
    tagName: 'h3',
}) `
	${blockListItemTitleStyles}
`;
